var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSendIcon = function SvgSendIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9.0-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.7.0-Minc-Admin-/-Marketing-messages--empty",
    transform: "translate(-1272.000000, -84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(256.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(1000.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8934375,9.09531249 L16.8884375,9.09312499 L3.54218746,3.55749996 C3.31417088,3.46206352 3.05347955,3.48741666 2.84812496,3.62499996 C2.63114204,3.76717828 2.50029485,4.0090224 2.49999978,4.26843746 L2.49999978,7.80874999 C2.49999978,8.16888157 2.75619827,8.47808795 3.10999996,8.54531249 L10.3890625,9.89125 C10.4480688,9.90243643 10.4907797,9.9540052 10.4907797,10.0140625 C10.4907797,10.0741198 10.4480688,10.1256886 10.3890625,10.136875 L3.11031246,11.4828125 C2.75661756,11.5498611 2.50045086,11.8587564 2.49999978,12.21875 L2.49999978,15.7596875 C2.49983137,16.0073903 2.62417911,16.2385902 2.83093746,16.375 C2.95337461,16.4563491 3.09706416,16.4998255 3.24406246,16.5 C3.34625634,16.5 3.44740256,16.4794054 3.54156246,16.4396875 L16.8875,10.935625 L16.8934375,10.9328125 C17.260629,10.7750092 17.4985978,10.4137267 17.4985978,10.0140625 C17.4985978,9.6143983 17.260629,9.25311581 16.8934375,9.09531249 Z",
    id: "send",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-icon.5a6540f1.svg";
export { ForwardRef as ReactComponent };